// VENDRA wordmark rendered as inline SVG so it stays crisp at every size
// without shipping a 1MB raster. Two variants:
//   <VendraMark />      — the wordmark alone (nav, footer)
//   <VendraMark tag />  — wordmark + rule + FOR LUXURY tagline (preloader,
//                         hero identity moments)
// Colours pull from the site's brass/gold tokens so the mark inherits the
// hover/emphasis states the rest of the site already uses.
export default function VendraMark({
  tag = false,
  className = "",
  color = "currentColor",
  ruleColor,
  tagColor,
}) {
  const rule = ruleColor ?? color;
  const sub = tagColor ?? color;
  return (
    <svg
      viewBox={tag ? "0 0 320 132" : "0 0 320 78"}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Vendra"
      data-testid="vendra-mark"
    >
      {/* Oversized V behind the wordmark */}
      <g fill={color}>
        <path
          d="M160 6 L120 74 L200 74 Z"
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeLinejoin="miter"
          opacity="0.9"
        />
      </g>
      {/* VENDRA — a display serif, letter-spaced to sit inside the V */}
      <text
        x="160"
        y="58"
        textAnchor="middle"
        fill={color}
        style={{
          fontFamily: "'DM Serif Display', 'Cormorant Garamond', serif",
          fontWeight: 400,
          fontSize: 34,
          letterSpacing: "0.28em",
        }}
      >
        VENDRA
      </text>
      {tag && (
        <>
          {/* Rule under the wordmark */}
          <line
            x1="100"
            x2="220"
            y1="98"
            y2="98"
            stroke={rule}
            strokeWidth="1.2"
            opacity="0.85"
          />
          {/* FOR LUXURY */}
          <text
            x="160"
            y="122"
            textAnchor="middle"
            fill={sub}
            style={{
              fontFamily: "'JetBrains Mono', 'Menlo', monospace",
              fontSize: 12,
              letterSpacing: "0.42em",
              fontWeight: 400,
            }}
          >
            FOR LUXURY
          </text>
        </>
      )}
    </svg>
  );
}
